import { UseFormReturn } from "react-hook-form";

export function formatCheckoutFormsToBasketEndpointsPayload(
  form: UseFormReturn
) {
  const formValues = form?.getValues() || {};
  const formKeys = Object.keys(formValues);

  const formKeyToCheckoutAddressMap: { [key: string]: string } = {
    info_home_address_street_name: "street_address",
    info_home_address_unit_number: "unit_number",
    info_home_address_city: "city",
    info_home_address_country: "country",
    info_home_address_province: "province",
    info_home_address_postal: "postal",
  };

  const formattedAddress = Object.keys(formKeyToCheckoutAddressMap).reduce(
    (acc, mapKey) => {
      const formKey = formKeys.find((k) => k.includes(mapKey));
      const formattedAddressKey = formKeyToCheckoutAddressMap[mapKey];

      return {
        ...acc,
        [formattedAddressKey]: formKey ? formValues[formKey] : undefined,
      };
    },
    {} as {
      street_address: string;
      city: string;
      province: string;
      postal: string;
      country: string;
      unit_number: string;
    }
  );

  return formattedAddress;
}
